module.exports = __webpack_public_path__ + "img/16.caefe6d1.jpg";